import { Component, DestroyRef, inject, OnInit, signal, ViewChild, ViewContainerRef } from '@angular/core';

import { DrawerModule } from 'primeng/drawer';
import { combineLatest, filter, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationStart } from '@angular/router';
import { SidebarType } from '../models/enums/sidebar-type.enum';
import { SidebarComponentConfig, SidebarComponentsConfiguration } from './sidebar.configuration';
import { SidebarService } from '../data-access/sidebar.service';

@Component({
  selector: 'app-sidebar-feature-sidebar',
  standalone: true,
  imports: [
    DrawerModule
],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  // inject
  private sidebarService = inject(SidebarService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  // public
  @ViewChild('container', { read: ViewContainerRef, static: false })
  public container!: ViewContainerRef
  public isSidebarLocked = false;
  // Signal so drawer visibility repaints on its own in the zoneless app (was a
  // plain property that needed a manual detectChanges to show).
  public visible = signal(false);
  public id: number | null = null;
  public type: SidebarType | null = null;
  public isLinkEditMode = false;
  public header?: string;

  ngOnInit() {
    this.sidebarService.isVisible$
      .pipe(
        tap((data) => {
          this.visible.set(data.isVisible);
        })
      ).subscribe(({ input }) => {
        if (this.visible()) {
          this.createComponentsBasedOnConfig(input);
        }
      });
    combineLatest({
      id: this.sidebarService.id$,
      type: this.sidebarService.type$,
      headerContent: this.sidebarService.headerContent$
    })
      .subscribe({
        next: (value) => {
          this.id = value.id;
          this.type = value.type;
          this.header = value.headerContent ?? ''
        }
      });

    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event) => event instanceof NavigationStart && this.visible())
      )
      .subscribe(() => {
        this.container.clear();
        this.close();
      });
  }

  createComponentsBasedOnConfig(input?: any) {
    this.container.clear();
    const matchedComponentConfig = SidebarComponentsConfiguration.find((config:SidebarComponentConfig) => config.componentType === this.type);
    if (matchedComponentConfig) {
      matchedComponentConfig.component()
        .then((component: any) => {
          const c = this.container.createComponent(component);
          if (input && input instanceof Object)
            for (const key of Object.keys(input))
         {
              (c.instance as any)[key] = input[key];
         }
        });
    }
  }

  close() {
    this.container.clear();
    this.sidebarService.hideSidebar();
  }
}
